module.exports = __webpack_public_path__ + "img/swiper-12.d75ceeec.png";